'use strict';
import {combineReducers} from 'redux';
import {activeTimers} from './activeTimersReducers';
import {ACTIVE_TIMERS_LIST_NAME, ASSET_TASK_LOG_NAME, PROJECT_TASK_LOG_NAME, TIMER_EXPORT_NAME} from '../redux/state';
import {reduxList as assetTaskTimerLogList} from '../redux/assetTaskTimerLog';
import {reduxList as projectTaskTimerLogList} from '../redux/projectTaskTimerLog';
import {reduxListExports as timerExports} from '../redux/timerExports';

export * from './state';

export const timers = combineReducers({
  [ACTIVE_TIMERS_LIST_NAME]: activeTimers,
  [ASSET_TASK_LOG_NAME]: assetTaskTimerLogList.reducers.reducer,
  [PROJECT_TASK_LOG_NAME]: projectTaskTimerLogList.reducers.reducer,
  [TIMER_EXPORT_NAME]: timerExports.reducers.reducer,
});

export const storageWhitelist = [
  ['timers', ACTIVE_TIMERS_LIST_NAME],
];



// WEBPACK FOOTER //
// ./src/js/timers/reducers/index.js